<template lang="">
  <div>
    <v-data-table
      mobile-breakpoint="0"
      :options.sync="pagination"
      :server-items-length="totalItems"
      :items-per-page="10"
      item-key="id"
      :headers="headers"
      :items="collections"
      :loading="loading"
      loading-text="Đang Tải"
      :footer-props="footerTable"
      sort-by="title"
      @input="$emit('update:selected', $event)"
    >
      <template v-slot:v-data-table-header>
        <div class="px-10"></div>
      </template>
      <template v-slot:no-data>
        <div class="my-16 font-weight-bold">
          <p>Hiện tại chưa có nhóm khoản phí trong danh sách.</p>
          <p>Vui lòng thực hiện thao tác thêm khoản phí ở phía trên.</p>
        </div>
      </template>
      <template v-slot:item.title="{ item }">
        <div class="text-truncate" style="max-width: 470px">
          <router-link :to="{ path: `/${$route.name}/${item.id}` }" class="text-decoration-none">{{
            item.title
          }}</router-link>
        </div>
      </template>
      <template v-slot:item.action="{ item }" class="text-center">
        <v-menu offset-y left v-if="item.category === 'custom'">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" icon>
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item>
              <v-list-item-title style="cursor: pointer" @click="$refs.updateCollection.openDialog(item.id)"
                >Chỉnh sửa nhóm</v-list-item-title
              >
            </v-list-item>
            <v-list-item>
              <v-list-item-title class="red--text accent-1" style="cursor: pointer" @click="deleteCollection(item.id)"
                >Xoá nhóm</v-list-item-title
              >
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>
    <CollectionUpdateDialog ref="updateCollection" />
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import CollectionUpdateDialog from '@/modules/tuitionFee/tuition-collection/CollectionUpdateDialog.vue'
const headerTable = [
  {
    text: 'Nhóm khoản phí ',
    value: 'title',
    align: 'left',
    sortable: false,
    show: true,
    width: '60%'
  },
  {
    text: 'Độ ưu tiên',
    value: 'rank',
    align: 'center',
    sortable: false,
    show: true,
    width: '30%'
  },
  {
    text: 'Thao tác',
    align: 'center',
    value: 'action',
    sortable: false,
    show: true,
    width: '10%'
  }
]
export default {
  components: {
    CollectionUpdateDialog
  },
  data() {
    return {
      headers: headerTable,
      pagination: {},
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      totalItems: 'tuitionFeeCollection/totalItems',
      collections: 'tuitionFeeCollection/collections',
      pageText: 'tuitionFeeCollection/pageText'
    }),
    footerTable() {
      let footer = {
        'items-per-page-text': 'Số nhóm khoản phí mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': 10,
        'page-text': this.pageText
      }
      if (this.totalItems > 100) {
        footer['items-per-page-options'] = [5, 10, 15]
      }
      return footer
    }
  },
  methods: {
    ...mapActions({
      fetchCollections: 'tuitionFeeCollection/fetchCollections',
      getCollectionByPagination: 'tuitionFeeCollection/getCollectionByPagination',
      removeCollection: 'tuitionFeeCollection/removeCollection'
    }),
    deleteCollection(id) {
      this.$dialog.confirm({
        title: 'Xác nhận xóa nhóm khoản phí?',
        text: '<div>Thao tác này sẽ không thể hoàn tác.<br/> Bạn có chắc chắn muốn xoá nhóm khoản phí?</div>',
        okText: 'XOÁ',
        type: 'delete',
        cancelText: 'HUỶ',
        done: async () => {
          try {
            this.removeCollection(id)
            this.$alert.deleteSuccess('nhóm khoản phí')
          } catch (e) {
            this.$alert.deleteError({
              title: 'Lỗi thao tác',
              description: 'Không thể nhóm khoản phí. Vui lòng thử lại'
            })
          }
        }
      })
    }
  },
  watch: {
    pagination: {
      async handler(newOptions, oldOptions) {
        if (newOptions && oldOptions) {
          this.loading = true
          await this.getCollectionByPagination({ page: newOptions.page, itemsPerPage: newOptions.itemsPerPage })
          this.loading = false
        }
      },
      immediate: true
    }
  }
}
</script>
<style lang=""></style>
